import { BaseSVGType } from '@/components/common/svg/types/svgTypes.ts';

const CrownShape = ({
  width = 100,
  height = 100,
  fillColor = '#000',
  style
}: BaseSVGType) => {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      style={style}
    >
      <g clipPath="url(#clip0_1072_581)">
        <path
          d="M9.74047 4.3048C10.1941 4.04683 10.5 3.55914 10.5 3C10.5 2.17157 9.82845 1.5 9 1.5C8.17155 1.5 7.5 2.17157 7.5 3C7.5 3.5604 7.80727 4.04902 8.2626 4.30654L8.25585 4.32026C7.76408 5.3452 7.08174 6.81356 6.02748 7.36481C5.16252 7.8171 3.91971 7.58955 2.99726 7.4208C2.95661 6.83644 2.4697 6.375 1.875 6.375C1.25368 6.375 0.75 6.87868 0.75 7.5C0.75 8.05102 1.14611 8.5095 1.66911 8.60617L3.87948 14.3127C4.21504 15.179 5.04855 15.75 5.97758 15.75H12.0224C12.9514 15.75 13.7849 15.179 14.1206 14.3127L16.3309 8.60617C16.8538 8.5095 17.25 8.05102 17.25 7.5C17.25 6.87868 16.7463 6.375 16.125 6.375C15.5417 6.375 15.0621 6.81889 15.0056 7.3873C14.0612 7.50975 12.8438 7.66597 11.9725 7.2104C10.9394 6.67023 10.2476 5.30308 9.74047 4.3048Z"
          fill={fillColor}
        />
      </g>
      <defs>
        <clipPath id="clip0_1072_581">
          <rect width="18" height="18" fill={fillColor} />
        </clipPath>
      </defs>
    </svg>
  );
};
export default CrownShape;
